import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Layout } from 'antd';

import LangSwitcher from './controls/LangSwitcher'
import './App.css';

class AppHeader extends Component {
  
    render() {
      let url = this.props.language === 'ru-RU' ? 'https://www.prnwatch.ru' : 'https://www.prnwatch.com';
      
      return (
        <>
          <Layout.Header style={{ height:'72px', background: '#fff', padding: 0 }}>
            <div className='pw_header'>
                <a href={url} target='_self' rel="noopener"> 
                    <div className='pw_header-pw_logo'/>
                </a>            
                <div className='pw_header-locale'>              
                  <LangSwitcher/>
                </div>         
            </div>
          </Layout.Header>
        </>
    );
  }
}

const mapStateToProps = store => {
  return {
    language: store.language.code,
  }
}

export default connect(mapStateToProps)(AppHeader);